import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from '../../../components'
import './filter.scss'
import FilterCiclo from './filterCiclo'
import FilterData from './filterData'
import { filterHandle, putFiltersProvisorio, setFiltersProvisorio } from '../redux/benchmarkActions'

export default () => {
  const dispatch = useDispatch()
  const { filters, listas: { typeSearch }, ciclos, sistema } = useSelector(state => state.layoutState)
  const { filtersProvisorio, projeto } = useSelector(state => state.benchmarkState)

  const nls = require(`../nls/${sistema.idioma}.json`)

  useEffect(() => {
    let filtros = filters

    if (!filters?.ciclo?.anoMes && ciclos.length) {
      filtros = {
        ...filtersProvisorio,
        ...filtros,
        ciclo: ciclos[0]
      }
    }

    dispatch(setFiltersProvisorio(filtros))

    if (projeto?.id) {
      dispatch(filterHandle({
        projetoID: projeto.id,
        projetoNome: projeto.nomeProjeto,
        params: filtros,
        filtersProvisorio,
        typeSelect: filtros.typeSelect
      }))
    }
  }, [ciclos, projeto?.id])

  const handleSearching = (params) => {
    if (!projeto?.id) {
      return
    }

    dispatch(filterHandle({
      projetoID: projeto.id,
      projetoNome: projeto.nomeProjeto,
      params,
      filtersProvisorio,
      typeSelect: params.typeSelect
    }))
  }

  const contentFilterType = (e) => {
    switch (e?.id) {
      case 'Ciclo':
        return <FilterCiclo />
      case 'Data':
        return <FilterData />
      default:
        return null
    }
  }

  return (
    <div className='box-benchmark-search box-content'>
      <div className='box-benchmark-search-box'>
        <div className='box-benchmark-search-type'>
          {
            typeSearch.map((type) => {
              return (
                              <Button
                data-cy='filter-type'
                data-cy-key={
                  type.id === 'Ciclo'
                    ? 'ciclo'
                    : type.id === 'Data'
                      ? 'data'
                      : undefined
                }
                data-cy-selected={
                  type.id === filtersProvisorio?.typeSelect?.id
                    ? 'true'
                    : 'false'
                }
                color='primary'
                type={type.id === filtersProvisorio?.typeSelect?.id ? 'btn' : 'link'}
                size='small'
                  onClick={() => dispatch(putFiltersProvisorio({ name: 'typeSelect', value: type }))}
                  key={type.id}
                >
                  {type.label}
                </Button>
              )
            })
          }

                  <p data-cy='filter-type-label'>
          {filtersProvisorio?.typeSelect?.text === 'Filtrar por Ciclo'
              ? nls.filtrarporciclo
              : nls.filtrarpordata}
          </p>
        </div>

        <div>
          {contentFilterType(filtersProvisorio?.typeSelect)}
        </div>
      </div>

      <div className='box-benchmark-search-action'>
              <Button
        data-cy='filter-search'
        color='primary'
        size='large'
        onClick={() => handleSearching(filtersProvisorio)}
        >
          {nls.pesquisar}
        </Button>
      </div>
    </div>
  )
}